import { logger } from './logger';

export async function fetchImageAsFile(
  imageUrl: string,
  fileName: string
): Promise<{ file: File; previewUrl: string } | null> {
  try {
    const response = await fetch(imageUrl);

    if (!response.ok) {
      logger.error(`Failed to fetch image: ${response.status} ${response.statusText}`, { url: imageUrl });
      return null;
    }

    const blob = await response.blob();
    
    // Validate if the fetched content is an image
    if (!blob.type.startsWith('image/')) {
      logger.error(`Fetched content is not an image: ${blob.type}`, { url: imageUrl });
      return null;
    }
    
    const imageFile = new File([blob], fileName, { type: blob.type });
    const previewUrl = URL.createObjectURL(blob); // Use blob for preview

    logger.info(`Successfully fetched image and created file object for ${fileName}`, { imageUrl });
    return { file: imageFile, previewUrl: previewUrl };
  } catch (error) {
    logger.error('Error fetching or converting image to File:', { error, imageUrl });
    return null;
  }
}
